import { render, staticRenderFns } from "./TwoFactorAuthCapture.vue?vue&type=template&id=4fa0c5d7&scoped=true&"
import script from "./TwoFactorAuthCapture.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthCapture.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuthCapture.vue?vue&type=style&index=0&id=4fa0c5d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa0c5d7",
  null
  
)

export default component.exports